import dayjs from "dayjs";
import "dayjs/locale/ko";
import customParseFormat from "dayjs/plugin/customParseFormat";

export const isApp = () => {};
export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};
export const getOs = (): "ios" | "android" | "unknown" => {
  let userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os: "ios" | "android" | "unknown" = "unknown";

  if (iosPlatforms.indexOf(platform) !== -1) {
    os = "ios";
  } else if (/Android/.test(userAgent)) {
    os = "android";
  }

  return os;
};
export const getOsByApp = () => {
  if (window.hasOwnProperty("wb_bridge")) {
    return "android";
  }
  if (window.hasOwnProperty("webkiet")) {
    return "ios";
  }
  return "unknown";
};
export const isWebview = () => {
  if (window.hasOwnProperty("wb_bridge") || window.hasOwnProperty("webkit")) {
    return true;
  }
  return false;
};
export const addComma = (x: any) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
};

// image url
export const getImageUrlWithMaxWidth = (url: string, maxWidth?: number) => {
  const w = maxWidth || 1200;
  return `https://imgs-v3.h2m.io/?url=${url}&w=${w}`;
};

// wait for
export const waitFor = async (milliSeconds: number) => {
  return new Promise<undefined>((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, milliSeconds);
  });
};

//
export const smoothScrollTo = (
  target: Window | HTMLElement,
  scrollTargetY: number,
  time?: {
    baseSpeed?: number;
    maxDuration?: number;
    minDuration?: number;
  },
) => {
  return new Promise((resolve) => {
    // 시작 스크롤 위치
    const startScrollTop = target instanceof Window ? window.scrollY : target?.scrollTop;

    // 스크롤 이동 거리 계산
    let distance = scrollTargetY - startScrollTop;

    // 최대 스크롤 위치
    const maxScrollY =
      target instanceof Window
        ? document.documentElement.scrollHeight - window.innerHeight
        : target.scrollHeight - target.clientHeight;

    const maxDistance = maxScrollY - startScrollTop;
    distance = Math.min(distance, maxDistance);

    // 기본 애니메이션 시간 설정
    const defaultDurationTime = {
      baseSpeed: 2000,
      maxDuration: 500,
      minDuration: 150,
    };
    const durationTime = time ? { ...defaultDurationTime, ...time } : defaultDurationTime;
    const baseSpeed = durationTime.baseSpeed;
    const maxDuration = durationTime.maxDuration;
    const minDuration = durationTime.minDuration;

    // 스크롤 거리 기반으로 애니메이션 시간 계산
    let duration = (Math.abs(distance) / baseSpeed) * 1000;
    duration = Math.max(minDuration, Math.min(duration, maxDuration)); // 최소, 최대 시간 제한

    // 애니메이션 시작 시간
    const startTime = performance.now();

    // 애니메이션 함수
    function scrollAnimation(currentTime: number) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // progress: 0에서 1까지

      // 스크롤 위치 계산 (progress에 따라 점점 목표 지점으로 이동)
      let scrollY = Math.floor(startScrollTop + (scrollTargetY - startScrollTop) * progress);
      if (distance > 0) {
        scrollY = Math.max(scrollY, 0);
      } else {
        scrollY = Math.min(scrollY, startScrollTop);
      }

      // 최대 스크롤 위치 제한
      scrollY = Math.min(scrollY, maxScrollY);
      target.scrollTo(0, scrollY);

      // 아직 애니메이션이 끝나지 않았다면 requestAnimationFrame으로 계속 호출
      if (progress < 1) {
        requestAnimationFrame(scrollAnimation);
      } else {
        // 애니메이션이 끝났을 때 Promise를 resolve하여 후속 처리를 할 수 있도록 함
        resolve(true);
      }
    }
    // 첫 번째 애니메이션 프레임 호출
    if (distance !== 0) {
      requestAnimationFrame(scrollAnimation);
    } else {
      resolve(true);
    }
  });
};

export const formatDate = (
  date: string | Date,
  format: string = "YYYY-MM-DD",
  initialFormat: string = "YYYY-MM-DD",
): string | null => {
  // 플러그인 추가
  dayjs.extend(customParseFormat);
  // dayjs locale 설정
  dayjs.locale("ko");

  let parsedDate = dayjs(date);
  if (initialFormat) {
    parsedDate = dayjs(date, initialFormat, "ko");
  }
  if (!parsedDate.isValid()) {
    console.error("Invalid date provided.");
    return null;
  }
  return parsedDate.format(format);
};
